
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductSpecificationsBooksDialog extends Serenity.EntityDialog<ProductSpecificationsBooksRow, any> {
        protected getFormKey() { return ProductSpecificationsBooksForm.formKey; }
        protected getIdProperty() { return ProductSpecificationsBooksRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSpecificationsBooksRow.localTextPrefix; }
        protected getService() { return ProductSpecificationsBooksService.baseUrl; }
        protected getDeletePermission() { return ProductSpecificationsBooksRow.deletePermission; }
        protected getInsertPermission() { return ProductSpecificationsBooksRow.insertPermission; }
        protected getUpdatePermission() { return ProductSpecificationsBooksRow.updatePermission; }

        protected form = new ProductSpecificationsBooksForm(this.idPrefix);

    }
}